$(document).ready(function () {


  $('html').removeClass('no-js');
                    
  /* Placeholder JS */
  /*==========================*/

  $('[placeholder]').each(function(){
    if ($(this).val() === '') {
      var hint = $(this).attr('placeholder');
      $(this).val(hint).addClass('hint');
    }
  });

  $('[placeholder]').focus(function() {
    if ($(this).val() === $(this).attr('placeholder')) {
      $(this).val('').removeClass('hint');
    }
  }).blur(function() {
    if ($(this).val() === '') {
      $(this).val($(this).attr('placeholder')).addClass('hint');
    }
  });                    

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });


  /* Resize content on form action */
  /*==========================*/

// $('#action, .button, .action_link a, #addresses .button').on( 'click', function (e) {
  $('#action, .action_link a, #addresses .button').on( 'click', function (e) {
    e.preventDefault();

    verticalCenterContent();

  });

  /* Mobile Menu */
  /*==========================*/

  $("#mobile-menu-items").hide();

  $('#show-menu').on('click', function (e) {
    e.preventDefault();
    $("#mobile-menu-items").slideToggle();
  });


  /* Image Zoom */
  /*==========================*/

  if ( $(window).width() > 765 ) {
    $('.zoom').wrap('<span style="display:inline-block"></span>')
      .css('display', 'block')
      .parent()
      .zoom();
  }


  /* Latest Products Change thumbnails and zoom image src */
  /*==========================*/
  var i = 0;
  $('.latest-product').each(function() {

      i++;
      $(this).attr('id', 'latest-product-' + i);

  });

  $('.product-photo-thumbs a, .thumbnails a').on('click', function (e) {
      e.preventDefault();
   
      var $this = $(this),
          $photo = $this.parents('.product-wrapper').find('.product-photo-container .zoom'),
          photo_fullsize = $this.attr('href');

      $photo.trigger('zoom.destroy'); 

      $photo.attr('src', photo_fullsize);

      if ( $(window).width() > 765 ) {
        $photo.css('display', 'block')
        .parent()
        .zoom();
      }

  });

  

  /* Custom Product Tabs */
  /*==========================*/
  
  /**
  LATEST PRODUCT 1
  **/


  // This first section is all about formatting the content correctly for tabs
  // Add the opening list tag before the first H5 within the description
  $('#latest-product-1 .product-tabs-wrapper h3:first-of-type').before('<ul class="tabs" />'); 

  $('#latest-product-1 .product-tabs-wrapper h3').each(function(index, value){
    // Assign them each a number, in order
    var num = index + 1;
    // For each H5, wrap everything from after the heading to just before the next one in a div
    // Give each div a unique ID that includes those assigned numbers
    $(this).nextUntil('h3').wrapAll('<div class="panel" id="tab' + num + '-one' + '" />');
    // For each h5, wrap the H5 itself in a list item and an anchor link to the div
    $(this).wrap('<li class="single-tab"><a href="#tab' + num + '-one' + '"></a></li>');
  });

  $('#latest-product-1  ul.tabs, #latest-product-1  .panel').wrapAll('<div class="tab-area" />');

  $('#latest-product-1 .tab-area').appendTo('.content');

  $('#latest-product-1 .single-tab').each(function(){
    // Move them into the list element
    var $this = $(this);
    $('#latest-product-1').find('ul.tabs').append($this);
  });



  /**
  LATEST PRODUCT 2
  **/

  $('#latest-product-2 .product-tabs-wrapper h3:first-of-type').before('<ul class="tabs" />'); 

  $('#latest-product-2 .product-tabs-wrapper h3').each(function(index, value){
    // Assign them each a number, in order
    var num = index + 1;
    // For each H5, wrap everything from after the heading to just before the next one in a div
    // Give each div a unique ID that includes those assigned numbers
    $(this).nextUntil('h3').wrapAll('<div class="panel" id="tab' + num + '-two' + '" />');
    // For each h5, wrap the H5 itself in a list item and an anchor link to the div
    $(this).wrap('<li class="single-tab"><a href="#tab' + num + '-two' + '"></a></li>');
  });

  $('#latest-product-2  ul.tabs, #latest-product-2  .panel').wrapAll('<div class="tab-area" />');

  $('#latest-product-2 .tab-area').appendTo('.content');

  $('#latest-product-2 .single-tab').each(function(){
    // Move them into the list element
    var $this = $(this);
    $('#latest-product-2').find('ul.tabs').append($this);
  });


  /**
  LATEST PRODUCT 3
  **/

  $('#latest-product-3 .product-tabs-wrapper h3:first-of-type').before('<ul class="tabs" />'); 

  $('#latest-product-3 .product-tabs-wrapper h3').each(function(index, value){
    // Assign them each a number, in order
    var num = index + 1;
    // For each H5, wrap everything from after the heading to just before the next one in a div
    // Give each div a unique ID that includes those assigned numbers
    $(this).nextUntil('h3').wrapAll('<div class="panel" id="tab' + num + '-three' + '" />');
    // For each h5, wrap the H5 itself in a list item and an anchor link to the div
    $(this).wrap('<li class="single-tab"><a href="#tab' + num + '-three' + '"></a></li>');
  });

  $('#latest-product-3  ul.tabs, #latest-product-3  .panel').wrapAll('<div class="tab-area" />');

  $('#latest-product-3 .tab-area').appendTo('.content');

  $('#latest-product-3 .single-tab').each(function(){
    // Move them into the list element
    var $this = $(this);
    $('#latest-product-3').find('ul.tabs').append($this);
  });


  /**
  SINGLE PRODUCT
  **/

  // This first section is all about formatting the content correctly for tabs
  // Add the opening list tag before the first H5 within the description
  $('#single-product #product-description h3:first-of-type').before('<ul class="tabs" />'); 

  // Loop through each H5 in the description
  $('#single-product #product-description h3').each(function(index, value){
    // Assign them each a number, in order
    var num = index + 1;
    // For each H5, wrap everything from after the heading to just before the next one in a div
    // Give each div a unique ID that includes those assigned numbers
    $(this).nextUntil('h3').wrapAll('<div class="panel" id="tab' + num + '" />');
    // For each h5, wrap the H5 itself in a list item and an anchor link to the div
    $(this).wrap('<li class="single-tab"><a href="#tab' + num + '"></a></li>');
  });

  $('#single-product  ul.tabs, #single-product  .panel').wrapAll('<div class="tab-area" />');

  $('#single-product .tab-area').appendTo('.content');

  $('#single-product .single-tab').each(function(){
    // Move them into the list element
    var $this = $(this);
    $('#single-product').find('ul.tabs').append($this);
  });




  // The rest of this is the actual tab functionality, from http://www.jacklmoore.com/notes/jquery-tabs/
  $('ul.tabs').each(function(){
    // For each set of tabs, we want to keep track of
    // which tab is active and it's associated content
    var $active, $content, $links = $(this).find('a');
    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    $active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
    $active.addClass('active');
    $content = $($active.attr('href'));
    // Hide the remaining content
    $links.not($active).each(function () {
      $($(this).attr('href')).hide();
    });
    // Bind the click event handler
    $(this).on('click', 'a', function(e){
      // Make the old tab inactive.
      $active.removeClass('active');
      $content.hide();
      // Update the variables with the new link and content
      $active = $(this);
      $content = $($(this).attr('href'));
      // Make the tab active.
      $active.addClass('active');
      $content.show();
      // Prevent the anchor's default click action
      e.preventDefault();
    });
  });


  $(window).resize( debouncer( function ( e ) {
    
    $('.latest-releases li.latest-product').css('height', 'auto');

    verticalCenterContent();

    resizeZoomImages();

    $('#products .product').height('auto'); //Reset height
    $('#products .product').equalHeights();


    // Remove zoom mobiles
    if ( $(window).width() < 765 ) {
      
      $('.zoom').trigger('zoom.destroy');

    } else {

      $('.zoom').trigger('zoom.destroy');

    }


     $.colorbox.remove();
     $(".lightbox").colorbox({ 
        transition:"fade",
        scalePhotos: true,
        reposition: true,
        maxWidth:'95%', 
        maxHeight:'95%'
      });

  }));



  //Function to check browser stopped resizing
  function debouncer( func , timeout ) {
    var timeoutID , timeout = timeout || 200;
    return function () {
      var scope = this , args = arguments;
      clearTimeout( timeoutID );
      timeoutID = setTimeout( function () {
          func.apply( scope , Array.prototype.slice.call( args ) );
      } , timeout );
    }
  }


});




$(window).load(function () {

  //Center contnet vertically and push footer to bottom of site if screen bigger enough
  verticalCenterContent();

    /* Set Latest Products to the same height */
  /*==========================*/
  var largestHeight = 0,
      $latestProduct = $('.latest-releases li.latest-product');
  
   $latestProduct.each(function () {

      var $this = $(this);

      if ($this.outerHeight() > largestHeight) {

          largestHeight = $this.outerHeight();

      }

  });

  if ( $(window).width() > 765 ) {

    $latestProduct.css('height', largestHeight);

  }


  /* Equal Height */
  /*==========================*/
  $('#products .product').equalHeights();


});


function resizeZoomImages () {

  $('.zoomContainer').remove();

}

function verticalCenterContent () {

  var $window = $(window),
      $footer = $('#footer'),
      windowHeight = $(window).height(),
      pageHeight = $('body').height(),
      mainContent = $('#main'),
      mainContentHalfHeight = mainContent.outerHeight() / 2;


  // console.log('windowHeight ' + windowHeight );
  // console.log('pageHeight ' + pageHeight );

  biggestPageElement = Math.max(pageHeight, mainContent.outerHeight());

  biggestPageElement = biggestPageElement + 100;

  if (windowHeight > biggestPageElement  && $window.width() > 720 && windowHeight > 550 && ! $('html').hasClass('lt-ie9') ) {

    mainContent.addClass('vertical-centered-content');
    mainContent.css('margin-top', - + mainContentHalfHeight);

    $footer.addClass('push-footer');

    // console.log('push footer');
   
  } else {

    mainContent.removeClass('vertical-centered-content');

    if ($window.width() < 770) {
      mainContent.css('margin-top', '10px');
    } else {
      mainContent.css('margin-top', '20px');
    }

    $footer.removeClass('push-footer');

    // console.log('stack footer');

  }

}


$(document).ready(function(){

  //If not cookie show popup
  if ($.cookie('test_status') !== '1') {
   
    $('.subs-popup ').show();
    $('.subs-popup-content').show();
    
    $.cookie('test_status', '1', { expires: 30 });

  } 

  $('#email-close').on( 'click', function() {
    $('.subs-popup').hide();
    $('.subs-popup-content').hide();
  }); 

});

